import * as React from "react";
import { Dropdown, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { UploadedTmpFile, UploadMode } from "./FileUploadStore";
import { projectsDataStore } from "Stores/ProjectsStore";
import { ItemType } from "antd/lib/menu/interface";

export type ActionCommand =
  | "metadata"
  | "rename"
  | "change_path"
  | "filename_assistant"
  | "replace_existing"
  | "replace_other"
  | "remove";

interface FileUploadActionsProps extends WithTranslation {
  file: UploadedTmpFile | API_UploadFile;
  onSelectFileAction: (command: ActionCommand, file: UploadedTmpFile | API_UploadFile) => void;
  module: UploadMode;
}

interface FileUploadActionsState {
  newFolderId: number;
  newFolderDirname: string;
  newFilename: string;
  fileIdToReplace: number;
}

export const FileUploadActions = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<FileUploadActionsProps, FileUploadActionsState> {
    get menuItems(): ItemType[] {
      const { t, file, module } = this.props;
      const items: ItemType[] = [];

      if (file.errors && file.errors.status === "MISSINGMETADATUM") {
        items.push({
          key: "metadata",
          label: t("Add metadata"),
        });
      }

      items.push({
        key: "rename",
        label: t("Change filename") + "...",
      });

      if (module === "DOCUMENTS") {
        items.push({
          key: "change_path",
          disabled: !file.changeTargetDir,
          label: (
            <>
              <Tooltip
                title={
                  file.changeTargetDir
                    ? null
                    : t("Automatic Directory Mapping active. You can’t change the target directory")
                }
              >
                {t("Change target directory")}...
              </Tooltip>
            </>
          ),
        });
      }

      if (
        projectsDataStore.currentProject.fileNameAssistant &&
        file.errors &&
        file.errors.status === "FILENAMECONVENTION_FILENAME"
      ) {
        items.push({
          key: "filename_assistant",
          label: <>{t("Filename assistant")}...</>,
        });
      }

      if (file.errors && file.errors.status === "REPLACE" && file.errors.existingFile && file.errors.existingFile.id) {
        items.push({
          key: "replace_existing",
          label: t("Replace existing file"),
        });
      } else if (file.replaceFileOption) {
        items.push({
          key: "replace_other",
          label: t("Replace file"),
        });
      }

      items.push({
        key: "remove",
        label: t("Remove"),
      });
      return items;
    }

    handleClick = ({ key }) => {
      const { file, onSelectFileAction } = this.props;
      onSelectFileAction(key as ActionCommand, file);
    };

    render() {
      return (
        <Dropdown menu={{ items: this.menuItems, onClick: this.handleClick }} trigger={["click"]}>
          <div className="text-center pointer" style={{ width: 25 }}>
            <FontAwesomeIcon icon={["far", "ellipsis-v"]} />
          </div>
        </Dropdown>
      );
    }
  }
);
